export const Origin = ({ props }) => ([
  { text: 'DeQS-Ergebnisse IQTIG (DeQS)', value: 'DeQS' },
  { text: 'PlanQI-Ergebnisse IQTIG (PlanQI)', value: 'PlanQI' },
  { text: 'Landesergnisse (Land)', value: 'Land' },
  { text: 'Kommentierung QB IQTIG (DeQS-QB)', value: 'DeQS-QB' },
])
